<!-- TEMPLATE -->
<template>
  <v-touch 
    @swipe="valueChanged">
    <div class="slidecontainer">
      <input 
        class="slider"
        type="range" 
        :id="id" 
        :min="min" 
        :max="max" 
        v-model="tempValue"
        @change="valueChanged"
        @mouseover="valueTextChanged(true)"
        @mouseleave="valueTextChanged(false)">
      <transition name="fade" mode="out-in" appear>
        <div v-if="valueText" class="value" ref="valueText" :style="valueStyle">{{ labelBefore }} {{ tempValue }} {{ label }} {{ labelAfter }}</div>
      </transition>
      <div class="percent" :style="percentageStyle"></div>
      <div class="bg"></div>
    </div>
  </v-touch>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import VueTouch from 'vue-touch';
import { Component, Prop, Watch } from 'vue-property-decorator';

Vue.use(VueTouch);

import uploadIcon from '../svg/feather-icons/upload.svg';

// COMPONENTS
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanIcon
  }
})
export default class deanInputNumberSlider extends Vue {
  @Prop() id!: string;
  @Prop() labelBefore!: string;
  @Prop() labelAfter!: string;
  @Prop() label!: string;
  @Prop({ default: 0 }) min!: number;
  @Prop({ default: 100 }) max!: number;
  @Prop({ default: 0 }) value!: number;
  @Prop({ default: true }) tooltip!: boolean;
  @Prop(/*{ default: 'var(--color-dark-shade-4)' }*/) bgColor!: string;
  tempValue: number = Number(this.value);
  valueTextMargin = Number(0)
  valueText = true

  @Watch('value')
    updateValue() {
      this.tempValue = Number(this.value);
      if (this.tempValue < this.min) {
        this.tempValue = this.min;
      } else if (this.tempValue > this.max) {
        this.tempValue = this.max
      }
    }

  get percentage() {
    let percentPerPoint = (100 / (this.max - this.min))
    let percentage = (this.tempValue - this.min) * percentPerPoint
    if (percentage > 100) percentage = 100
    if (percentage < 0) percentage = 0
    return percentage
  }

  get percentageStyle() {
    let margin = 30 - ((50/100 )* this.percentage);
    return {
      '--width': 'calc(' + this.percentage + '% + ' + margin + 'px)',
      '--bg-color': this.bgColor
    }
  }

  get valueStyle() {
    console.log(this.valueTextMargin)
    return {
      '--left': this.percentageStyle['--width'] ,
      '--margin-left': "-" + ((this.valueTextMargin / 2) + 1) + 'px'
    }
  }

  valueChanged() {
    this.valueTextMargin = this.$refs.valueText["clientWidth"];
    console.log(this.tempValue)
    this.$emit('value', {id: this.id, value: this.tempValue });
  }

  valueTextChanged(value) {
    if (this.tooltip == false) {
      this.valueText = value
    }
  }

  mounted() {
    this.valueTextMargin = this.$refs.valueText["clientWidth"];
    this.valueTextChanged(false);
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';
.slidecontainer {
  position: relative;
  width: 100;
  padding: 20px 10px 5px 10px;
}

.slider {
  position: absolute;
  top: 20px;
  left: 10px;
  width: calc(100% - 20px);
  height: 30px;
  background: none;
  border-radius: 100px;
  border: 0;
  cursor: pointer;
  padding: 0px 2px 0px 2px;
  -webkit-transition: .2s;
  transition: .2s;
  -webkit-appearance: none;
  outline: none;
  user-select: none;
  box-sizing: border-box;
  z-index: 2;
  &:hover {
    outline: none;
    background-position: left bottom;
    box-shadow: 0px 0px 10px 2px var(--color-link, $color-link);
  }
}

.slider::-moz-focus-outer {
  border: 0;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 26px;
  height: 26px;
  background: #FFF;
  cursor: pointer;
  border: 0;
  @include border-radius(50%);
  @include box-shadow(2px 0px 5px rgba(0, 0, 0, 0.15));
}

.slider::-moz-range-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 26px;
  height: 26px;
  background: #FFF;
  cursor: pointer;
  border: 0;
  @include border-radius(50%);
  @include box-shadow(2px 0px 5px rgba(0, 0, 0, 0.15));
}

.value {
  position: absolute;
  top: 0px;
  left: var(--left);
  margin-left: var(--margin-left);
  padding: 2px 5px 2px 5px;
  height: 19px;
  color: white;
  font-size: 11px;
  font-weight: 500;
  z-index: 3;
  background: rgba(83, 86, 90, 0.9);
  border-radius: 100px;
  white-space: nowrap;
}

.percent {
  position: absolute;
  top: 20px;
  left: 10px;
  -webkit-appearance: none;
  width: var(--width);
  height: 30px;
  background: var(--color-info-success, $color-info-success);
  outline: none;
  border-radius: 100px;
  cursor: pointer;
  z-index: 1;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-image: linear-gradient(
    -45deg,
    rgba(0,0,0, 0.05) 25%,
    transparent 25%,
    transparent 50%,
    rgba(0,0,0, 0.05) 50%,
    rgba(0,0,0, 0.05) 75%,
    transparent 75%,
    transparent
    );
    background-size: 25px 25px;
    animation: move 2s linear infinite;
    border-radius: 100px;
  }
}

.bg {
  position: relative;
  -webkit-appearance: none;
  width: 100%;
  height: 30px;
  border-radius: 100px;
  border: 1px solid  var(--color-light-shade-2, $color-light-shade-2);
  background: var(--color-light, $color-light);
}
</style>
